import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import { format, formatDistance, formatISO } from "date-fns";

import * as styles from "./Number.module.scss";


const Number = ({ data }) => {
  return (
    <div className={styles.el}>
      <span className={styles.number}>#{data.number}</span>
      <time
        className={styles.date}
        dateTime={formatISO(new Date(data.played_on))}
        title={formatDistance(new Date(data.played_on), new Date()) + " ago"}
      >
        {format(new Date(data.played_on), "MMM yyyy")}
      </time>
      <span className={styles.host.name}>
        <Link to={`/${data.host.name}`}>
          {data.host.display_name}
        </Link>
      </span>
    </div>
  );
};

Number.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object,
};

export default Number;
